export var buildEnv = {
    buildMode: 'release',
    datacenter: 'us',
    sdkVersion: '2.1.0',
};
//# sourceMappingURL=buildEnv.js.map